<template>
<setup-wizard-component
	:sections="sections"
	:question-change-listener="questionChangeListener"
	route-segment="setup"
	:complete-message="completeMessage"
	v-on:activeQIndexChange="activeQIndexChange"
	v-on:activeSecIndexChange="activeSecIndexChange">

	<div v-if="sections[activeSecIndex].key == 'intro'" style="font-size: 16pt;font-weight: 300;">
		<p>The first order of business is to tell us about your company and how you operate so {{$store.appName}} can fit into how you run your business.</p>
		<p>This step-by-step guide should take about 10 minutes. If you run into some areas that requires information that someone else in your company needs to provide, you can use the 'Share section link' button at the top to give them direct access to the setup guide.</p>
		<p>Your progress will be saved as you go, so feel free to take as long as you need to complete the setup process, but it must be finished in order for {{$store.appName}} to start providing value.</p>
		<p>To get started, click the button below!</p>
	</div>

	<subscription-choices
		v-else-if="sections[activeSecIndex].key == 'subscribe'"
		redirect-thankyou-custom="/setup/3"
		redirect-error-customer="/setup/3"
		v-model="selectedSubscriptionStripeId"
		v-on:input="subscriptionChoiceChange"
		class="mb-2">
	</subscription-choices>

	<onboarding-packages
		v-else-if="sections[activeSecIndex].key == 'onboardingPackages'">
	</onboarding-packages>

	<div v-else-if="sections[activeSecIndex].key == 'success'" style="font-size: 16pt;font-weight: 300;">
		<p>That's all for now! A {{ $store.appName }} onboarding specialist will contact you soon</p>
	</div>
	
</setup-wizard-component>
</template>
<script type="text/javascript">
import SetupWizardComponent from "@/pages/setup_wizard/SetupWizardComponent"

import SubscriptionChoices from "@/pages/setup_wizard/SubscriptionChoices"
import OnboardingPackages from "@/pages/setup_wizard/OnboardingPackages"

export default {
	name: "SetupWizard",
	components: {
		SetupWizardComponent,
		SubscriptionChoices,
		OnboardingPackages
	},
	data() {
		return {
			activeSecIndex: 0,
			activeQIndex: 0,
			questionChangeListener: 0,
			selectedSubscriptionStripeId: null,
			includeUnionSetup: false,
			hasSubscriptionPackageSelected: false,
			headOfficeAddress: null,
			businessTypes: [],
			completeMessage: "<p>Congrats, you've successfully registered to tradetraks. Our training staff has been notified and someone will be in touch with you shortly to schedule.</p>"
		}
	},
	computed: {	
		sections() {
			return [
				{
					key: "intro",
					sectionHeading: "Welcome to Tradetraks!",
					nextButtonText: "Get Started",
					hideSkip: true,
					isCustom: true
				},
				{
					key: "companyDetails",
					apiScope: ["Company"],
					sectionHeading: "Company Details",
					questions: [
						{
							question: "What type of business do you operate?",
							description: "This will help Tradetraks customize your company profile to meet the needs of your industry",
							moreInfo: "",
							fields: [
								{
									vmodel: "business_type",
									label: "Business Type",
									params: {
										type: 'select',
										options: this.businessTypes.map(type => type.type)
									}
								}
							],
							payload: {
								business_type: ""
							},
							saveEndpoint: "Company/save",
							findEndpoint: "Company/mine"
						},
						{
							question: "Head Office Address",
							description: "Help us build our your company profile",
							moreInfo: "",
							fields: [
								{
									vmodel: "company_name",
									label: "Company Name",
									params: {}
								},
								{
									vmodel: "address",
									label: "Address",
									params: {}
								},
								{
									vmodel: "city",
									label: "City",
								},
								{
									vmodel: "province",
									label: "Province/State",
									params: {
										type: "province"
									}
								},
								{
									vmodel: "country",
									label: "Country",
								},
								{
									vmodel: "postal_code",
									label: "Postal Code/Zip",
									params: {}
								}
							],
							payload: {
								company_name: "",
								address: "",
								city: "",
								province: "",
								country: "",
								postal_code: ""
							},
							saveEndpoint: "Company/save",
							findEndpoint: "Company/mine"
						},
						{
							question: "Company Billing Address",
							description: "If your billing address is different than your head address, enter it here",
							moreInfo: "",
							questionButton: {
								buttonText: "Copy from Office Address",
								clickFunction: () => {
									this.headOfficeAddress = this.sections[this.activeSecIndex].questions[this.activeQIndex-1].payload
								}
							},
							fields: [
								{
									vmodel: "billing_address",
									label: "Address",
									params: {}
								},
								{
									vmodel: "billing_city",
									label: "City",
								},
								{
									vmodel: "billing_province",
									label: "Province/State",
									params: {
										type: "province"
									}
								},
								{
									vmodel: "billing_country",
									label: "Country",
								},
								{
									vmodel: "billing_postal_code",
									label: "Postal Code/Zip",
									params: {}
								}
							],
							payload: {
								billing_address: this.headOfficeAddress ? this.headOfficeAddress.address : "",
								billing_city: this.headOfficeAddress ? this.headOfficeAddress.city : "",
								billing_province: this.headOfficeAddress ? this.headOfficeAddress.province : "",
								billing_country: this.headOfficeAddress ? this.headOfficeAddress.country : "",
								billing_postal_code: this.headOfficeAddress ? this.headOfficeAddress.postal_code : ""
							},
							saveEndpoint: "Company/save",
							findEndpoint: "Company/mine"
						},
						{
							question: "Public Company Information",
							description: "",
							moreInfo: "",
							fields: [
								{
									vmodel: "phone",
									label: "Phone",
									params: {}
								},
								{
									vmodel: "email",
									label: "Email",
								},
								{
									vmodel: "website",
									label: "Website URL",
									params: {
										placeholder: "https://yourwebsite.com",
										type: "url"
									}
								},
								{
									vmodel: "facebook",
									label: "Facebook",
									params: {
										placeholder: "ex. @tradetraks"
									}
								},
								{
									vmodel: "linked_in",
									label: "LinkedIn",
									params: {
										placeholder: "ex. https://www.linkedin.com/company/tradetraks"
									}
								},
								{
									vmodel: "instagram",
									label: "Instagram",
									params: {
										placeholder: "ex. @tradetraks"
									}
								},
								{
									vmodel: "twitter",
									label: "Twitter",
									params: {
										placeholder: "ex. @tradetraks"
									}
								},
								{
									vmodel: "description",
									label: "Company Description",
									params: {
										type: 'textarea',
										placeholder: "Add a description to your profile so people know what your company does."
									}
								}
							],
							payload: {
								phone: "",
								email: "",
								website: "",
								description: "",
								facebook: "",
								twitter: "",
								instagram: "",
								linked_in: ""
							},
							saveEndpoint: "Company/save",
							findEndpoint: "Company/mine"
						},
						{
							question: "Branding",
							description: "",
							moreInfo: "",
							fields: [
								{
									vmodel: "profileImage",
									label: "Logo",
									params: {
										type: 'image',
										apiResource: "ProfileImage"
									}
								},
							],
							payload: {
								profileImage: null,
							},
							saveEndpoint: "Company/save",
							findEndpoint: "Company/mine",
							findParams: {
								include: ["ProfileImage"]
							},
							setPayload(payload) {
								return {
									profileImage: payload.ProfileImage
								}
							},
							mutatedPayload(payload) {
								return {
									image_id: "profileImage" in payload && payload.profileImage ? payload.profileImage.id : null
								}
							}
						}
					]
				},
				{
					key: "subscribe",
					isCustom: true,
					sectionHeading: "Subscribe",
					hideSkip: true,
					mandatory: {
						value: this.hasSubscriptionPackageSelected,
						equals: true
					}
				},
				{
					key: "onboardingPackages",
					isCustom: true,
					sectionHeading: "Onboarding Package",
					hideSkip: true,
					mandatory: {
						value: this.hasOnboardingPackage,
						equals: true
					}

				}
			]
		},
		hasOnboardingPackage() {
			if (this.$store.company.onboarding_package_purchased_id > 0)
				return true

			return false
		}
	},
	methods: {
		activeSecIndexChange(index) {
			this.activeSecIndex = index
		},
		activeQIndexChange(index) {
			this.activeQIndex = index
		},
		setSubscriptionSelectedStatus() {
			let cart = []
			try {
				cart = JSON.parse(localStorage.getItem("cart"))
			}
			catch (e) {}

			if (cart && cart.find(item => item.search("plan_") >= 0))
				this.hasSubscriptionPackageSelected = true
			else
				this.hasSubscriptionPackageSelected = false
		},
		subscriptionChoiceChange(plan_id) {
			if (plan_id)
				this.hasSubscriptionPackageSelected = true
		},
		fetchBusinessTypes() {
			let vm = this

			this.getJSON("BusinessType/get").then(response => {
				if (response.success)
					vm.businessTypes = response.data
			})
		}
	},
	created() {
		this.setSubscriptionSelectedStatus()
		this.fetchBusinessTypes()
	}
}
</script>